import { render, staticRenderFns } from "./ButtonAddAsset.vue?vue&type=template&id=0c8b1779&scoped=true"
import script from "./ButtonAddAsset.vue?vue&type=script&lang=js"
export * from "./ButtonAddAsset.vue?vue&type=script&lang=js"
import style0 from "./ButtonAddAsset.vue?vue&type=style&index=0&id=0c8b1779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b1779",
  null
  
)

export default component.exports